import { Auth0Client } from "@auth0/auth0-spa-js"
import { useGrowthBook } from "@growthbook/growthbook-react"
import { FC, useEffect } from "react"

interface Props {
  auth0: Auth0Client
}

const GrowthbookAttributes: FC<Props> = ({ auth0 }) => {
  const gb = useGrowthBook()

  useEffect(() => {
    const getUserEmail = async () => {
      const isAuthenticated = await auth0.isAuthenticated()
      if (isAuthenticated) {
        const user = await auth0.getUser()

        gb.setAttributes({
          email: user?.email,
        })
      }
    }
    getUserEmail()
  }, [auth0, gb])

  return null
}

export default GrowthbookAttributes
